import React from 'react';
import { BaseDialog } from '@metarouter-private/mr-mui';
import useBaseDialogProps from './useBaseDialogProps';

export default function BulkDeployDiffModal() {
  const props = useBaseDialogProps();

  return <BaseDialog {...props} data-test-id="bulkDeployDiffModal" />;
}
